import { ProjectOverviewFieldsProps } from 'components/ProjectOverview';
import { cityNameFromFirstCapital } from './cityNameFromFirstCapital';
export const sortFilteredItems = (items: ProjectOverviewFieldsProps[]) => {
  return items
    .sort((a, b) => {
      const areaA = a.fields.workingArea.value;
      const areaB = b.fields.workingArea.value;

      if (areaA < areaB) return -1;
      if (areaA > areaB) return 1;
      return 0;
    })
    .sort((a, b) => {
      const cityA = cityNameFromFirstCapital(a.fields.city.value);
      const cityB = cityNameFromFirstCapital(b.fields.city.value);

      if (cityA < cityB) return -1;
      if (cityA > cityB) return 1;
      return 0;
    });
};
